import { MY_ASTER_CATEGORY, PAGE_TYPE } from "@common/Constants/analytics";
import { useEffect } from "react";

const analyticsState = {
  screenName: null,
  pageType: null,
  myAsterCategory: null,
};

const getDefaultAnalyticsState = () => ({
  screenName: window?.location?.pathname || "Home",
  pageType: PAGE_TYPE.HOME,
  myAsterCategory: MY_ASTER_CATEGORY.ASCO,
});

export const setAnalyticsState = (screenName, pageType, myAsterCategory) => {
  analyticsState.screenName = screenName || analyticsState.screenName;
  analyticsState.pageType = pageType || analyticsState.pageType;
  analyticsState.myAsterCategory = myAsterCategory || analyticsState.myAsterCategory;
};

export const getAnalyticsState = () => {
  if (!analyticsState.screenName) {
    const defaults = getDefaultAnalyticsState();
    analyticsState.screenName = defaults.screenName;
    analyticsState.pageType = defaults.pageType;
    analyticsState.myAsterCategory = defaults.myAsterCategory;
  }
  return analyticsState;
};

// Hook for components
export const useSetCommonParams = ({ screen, page, category }) => {
  useEffect(() => {
    setAnalyticsState(screen, page, category);
  }, []);
};

// Function for non-component use cases
export const setCommonParams = ({ screen, page, category }) => {
  setAnalyticsState(screen, page, category);
};